export default {
	gb: {
		global: {
			gallery: 'Photo gallery',
			locationTitle: 'Location & Contact information',
			apartment: 'Apartment',
		},
		welcomePage: {
			title: 'Welcome to PALMA!',
			text: "Nestled on the picturesque island of Krk, in the charming fisherman's village of Njivice, our apartment offers the perfect blend of relaxation and adventure.\nEnjoy a tranquil beachside retreat while being just a short distance from Krk's stunning sights, as well as nearby islands, the vibrant city of Rijeka, and the scenic Istria region—all within a half-hour drive.",
			explore: "Explore here",
			islandKrk: "Island Krk",
			rijeka: "Rijeka",
			istria: "Istria",
			baska: "Baška",
			opatija: "Opatija",
		},
		aboutPage: {
			title: 'About the apartment',
			text: "Palma is an apartment for 4 with 1 bedroom for 2 guests and one sofa bed for 2 extra guests in the living room, a bathroom with shower and toilet, kitchen and a beautiful large terrace."
		},
		services: {
			beach: 'Beach - 70m',
			parking: '1 private parking space',
			terrace: 'Private terrace',
			freeWifi: 'Free WiFi',
			ac: 'Air conditioning',
			laundryWasher: 'Laundry washer',
			dishWasher: 'Dishwasher',
			microwave: 'Microwave',
			coffeeMachine: 'Coffee machine',
			tv: 'TV',
		},
	},
	hr: {
		global: {
			gallery: 'Foto galerija',
			locationTitle: 'Lokacija i kontakt informacije',
			apartment: 'Apartman',
		},
		welcomePage: {
			title: 'Dobrodošli u PALMU!',
			text: "Smješten na slikovitom otoku Krku, u šarmantnom ribarskom mjestu Njivice, naš apartman nudi savršenu kombinaciju opuštanja i avanture.\nUživajte u mirnom odmoru uz more, dok ste u neposrednoj blizini prekrasnih znamenitosti otoka Krka, obližnjih otoka, živahnog grada Rijeke i slikovite regije Istre - sve unutar pola sata vožnje.",
			explore: "Istraži ovdje",
			islandKrk: "Otok Krk",
			rijeka: "Rijeka",
			istria: "Istra",
			baska: "Baška",
			opatija: "Opatija",
		},
		aboutPage: {
			title: 'O apartmanu',
			text: "Palma je apartman za 4 osobe s 1 spavaćom sobom za 2 gosta i jednim kaučem na razvlačenje za 2 dodatna gosta u dnevnom boravku, kupaonicom s tušem i WC-om, kuhinjom i prekrasnom velikom terasom."
		},
		services: {
			beach: 'Plaža - 70m',
			parking: '1 privatno parkirno mjesto',
			terrace: 'Privatna terasa',
			freeWifi: 'Besplatan WiFi',
			ac: 'Klima uređaj',
			laundryWasher: 'Perilica rublja',
			dishWasher: 'Perilica posuđa',
			microwave: 'Mikrovalna pećnica',
			coffeeMachine: 'Aparat za kavu',
			tv: 'TV',
		},
	},
	de: {
		global: {
			gallery: 'Fotogalerie',
			locationTitle: 'Standort & Kontaktinformationen',
			apartment: 'Apartment',
		},
		welcomePage: {
			title: 'Willkommen bei PALMA!',
			text: "Eingebettet auf der malerischen Insel Krk, im charmanten Fischerdorf Njivice, bietet unser Apartment die perfekte Mischung aus Entspannung und Abenteuer.\nGenießen Sie einen ruhigen Strandurlaub und sind Sie nur eine kurze Entfernung von den atemberaubenden Sehenswürdigkeiten von Krk, den nahe gelegenen Inseln, der lebhaften Stadt Rijeka und der malerischen Region Istrien entfernt - alles innerhalb einer halben Stunde Fahrt.",
			explore: "Hier erkunden",
			islandKrk: "Insel Krk",
			rijeka: "Rijeka",
			istria: "Istrien",
			baska: "Baška",
			opatija: "Opatija",
		},
		aboutPage: {
			title: 'Über die Wohnung',
			text: "Palma ist eine Wohnung für 4 Personen mit 1 Schlafzimmer für 2 Gäste und einem Schlafsofa für 2 zusätzliche Gäste im Wohnzimmer, einem Badezimmer mit Dusche und WC, Küche und einer schönen großen Terrasse.",
		},
		services: {
			beach: 'Strand - 70m',
			parking: '1 privater Parkplatz',
			terrace: 'Private Terrasse',
			freeWifi: 'Kostenloses WLAN',
			ac: 'Klimaanlage',
			laundryWasher: 'Waschmaschine',
			dishWasher: 'Geschirrspüler',
			microwave: 'Mikrowelle',
			coffeeMachine: 'Kaffeemaschine',
			tv: 'Fernseher',
		},
	},
	it: {
		global: {
			gallery: 'Galleria fotografica',
			locationTitle: 'Posizione e informazioni di contatto',
			apartment: 'Appartamento',
		},
		welcomePage: {
			title: 'Benvenuti a PALMA!',
			text: "Immerso nella pittoresca isola di Krk, nel suggestivo villaggio di pescatori di Njivice, il nostro appartamento offre il perfetto mix di relax e avventura.\nGoditi una tranquilla vacanza al mare mentre sei a breve distanza dalle splendide attrazioni di Krk, dalle isole vicine, dalla vivace città di Rijeka e dalla pittoresca regione dell'Istria - tutto a mezz'ora di macchina.",
			explore: "Esplora qui",
			islandKrk: "Isola di Krk",
			rijeka: "Rijeka",
			istria: "Istria",
			baska: "Baška",
			opatija: "Opatija",
		},
		aboutPage: {
			title: 'Informazioni sull\'appartamento',
			text: "Palma è un appartamento per 4 persone con 1 camera da letto per 2 ospiti e un divano letto per 2 ospiti aggiuntivi nel soggiorno, un bagno con doccia e WC, cucina e una bellissima terrazza grande.",
		},
		services: {
			beach: 'Spiaggia - 70m',
			parking: '1 posto auto privato',
			terrace: 'Terrazza privata',
			freeWifi: 'WiFi gratuito',
			ac: 'Aria condizionata',
			laundryWasher: 'Lavatrice',
			dishWasher: 'Lavastoviglie',
			microwave: 'Forno a microonde',
			coffeeMachine: 'Macchina da caffè',
			tv: 'TV',
		},
	},
};
